import { render, staticRenderFns } from "./FullHeightBaseBox.vue?vue&type=template&id=1424aed9&scoped=true&"
import script from "./FullHeightBaseBox.vue?vue&type=script&lang=js&"
export * from "./FullHeightBaseBox.vue?vue&type=script&lang=js&"
import style0 from "./FullHeightBaseBox.vue?vue&type=style&index=0&id=1424aed9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1424aed9",
  null
  
)

export default component.exports